import React from "react";
import close from "./../../assets/close.png";
import "./Popup.scss";
const Popup = (props) => {
  const { text = "", okBtn = false } = props;
  const closeHandler = () => {
    props.onClick();
  };

  return (
    <div className="popup-wraper">
      <div className="popup-content">
        {!okBtn && (
          <div className="close-btn" onClick={closeHandler}>
            <img src={close} alt="close" />
          </div>
        )}

        <div className="popuptext">
          <p>{text !== "" ? text : "Something went worng! "}</p>
        </div>
        {okBtn && (
          <div>
            <p className="click-continue">Click to OK for continue!</p>
            <div className="ok-btn" onClick={closeHandler}>
              Ok
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default Popup;
